module.exports = __webpack_public_path__ + "static/img/fivetigers_esp.c264226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/fivetigers_esp.png
// module id = +wQO
// module chunks = 1